export const changeStyleSalesTitles = () => {


  jQuery('#sportspage-subcategoriesfloor .sub-category').each(function(){
    const text=jQuery(this).find('h3 a').text();
    
    if (text.toUpperCase().indexOf('OFERTA')>-1){
      jQuery(this).addClass('saleStyle');
    }

    const sublinks=jQuery(this).find('.sub-category__item').length;
    
    if (sublinks<=1){
      jQuery(this).addClass('preventLink');
    }
  });

  jQuery('#sportspage-subcategoriesfloor .sub-category.preventLink').on('click',function(e){

    e.preventDefault();
    const link=jQuery(this).find('h3 a').attr('href');
    window.location.href=link;
    
  });

};


// WEBPACK FOOTER //
// ./src/_override/catalog/sportpage/sales-style.js